import {
  fmesh,
  fullmesh
} from './globalVariables.js';
import harrierPolygonLayer from './harrierPolygonLayer.js';

const ResetMapToOriginalData = async (globalRefs, globalState) => {
  let mapRef = globalRefs.mapRef;
  let drawRef = globalRefs.drawRef;
  let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
  let longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
  let selectedYearEditing = globalState.selectedYearEditing;
  let isDrawing = globalState.isDrawing;
  let centroidRef = globalRefs.centroidRef;
  let universalParcelDifferentiator = globalState.universalParcelDifferentiator;
  let universalColorPaletteName = globalState.universalColorPaletteName;
  let landKeySelectedKey = globalState.landKeySelectedKey;
  let originalGeoJSONforComparingRef = globalRefs.originalGeoJSONforComparingRef;

  longstandingGeoJSONRef.current = JSON.parse(JSON.stringify(originalGeoJSONforComparingRef.current));

  if (isDrawing) {
    mapRef.current.removeControl(drawRef.current);
  }
  fmesh.children.forEach((child) => {
    child.geometry.dispose();
    child.material.dispose();
  });
  fullmesh.children.forEach((child) => {
    fullmesh.remove(child);
  });
  fmesh.children.forEach((child) => {
    fmesh.remove(child);
  });
  fmesh.children.length = 0;
  fullmesh.children.length = 0;
  mapRef.current.removeLayer('Polygons');
  polygonCustomLayerRef.current = new harrierPolygonLayer(
    'Polygons',
    centroidRef.current.geometry.coordinates[1],
    centroidRef.current.geometry.coordinates[0],
    longstandingGeoJSONRef.current,
    globalRefs,
    globalState,
    universalColorPaletteName,
    universalParcelDifferentiator
  );
  mapRef.current.addLayer(polygonCustomLayerRef.current);
  if (mapRef.current.getLayer('scenario-modelling-feature-outline')) {
    mapRef.current.moveLayer('scenario-modelling-feature-outline');
  }
  polygonCustomLayerRef.current.getRandomPolygonColor(landKeySelectedKey);
}

export default ResetMapToOriginalData;
